<template>
  <div class="input-model-box">
    <el-input
      placeholder="请输入名称或编码"
      v-model="supplierName"
      @blur="supplierNameChange"
      :disabled="column.disabled"
    >
      <template slot="append">
        <div class="el-icon-more more-btn" @click="showSupplierList"></div>
      </template>
    </el-input>
    <el-dialog
      :title="column.label"
      :visible.sync="dialogVisible"
      @close="beforeClose"
      center
      :modal-append-to-body="false"
    >
      <purchase-list-template
        ref="listTable"
        @rowClick="supplierCheck"
        :tableOptions="tableOptions"
      ></purchase-list-template>
    </el-dialog>
  </div>
</template>
<script>
  import api from "@/config/api";

  import purchaseListTemplate from "@/components/template/purchaseListTemplate.vue";

  export default {
    components: {purchaseListTemplate},
    props: ["column", "defaultValue"],
    data() {
      return {
        supplierName: "",
        checkList: [],
        dialogVisible: false,
        supplierList: null,
        tableOptions: {
          url: api.archives.supplier + "/page",
          height: "100%",
          isRowClick: true,
          params: this.column.params,
          columns: [
            {label: "编码", prop: "code", align: "center"},
            {label: "名称", prop: "name", align: "center"}
          ]
        },
        btnClick: false
      };
    },
    watch: {
      defaultValue() {
        if (this.defaultValue > 0){
          this.$axios
            .fetchGet(api.archives.supplier + "?id=" + this.defaultValue)
            .then(res => {
              console.log(res);
              this.supplierName = res.data.name;
            });
        }
      }
    },
    methods: {
      initData() {
        this.supplierName = "";
        this.checkList = {};
      },
      showSupplierList() {
        if (this.column.disabled) return;
        this.btnClick = true;
        this.dialogVisible = true;
        this.getSupplierList();
      },
      supplierNameChange() {
        if (this.btnClick) return;
        if (this.supplierName === "" || this.supplierName === null) return;
        this.dialogVisible = true;
        this.getSupplierList();
      },
      getSupplierList() {
        if (this.btnClick) this.supplierName = "";
        this.supplierList = [];
        this.$nextTick(() => {
          this.$refs["listTable"].initData({
            storeId: this.column.params && this.column.params.storeId,
            type: this.column.params && this.column.params.type,
            otherName: this.supplierName
          });
          this.setSupplierName();
        });
      },
      setSupplierName() {
        if (this.supplierList.length === 1) {
          this.checkList = this.supplierList[0];
          this.supplierName = this.supplierList[0].name;
          this.$emit("valueChange", this.checkList.id, this.column);
        } else {
          this.dialogVisible = true;
        }
      },
      supplierCheck(row) {
        this.checkList = row;
        this.supplierName = row.name;
        this.dialogVisible = false;
        this.$emit("valueChange", row.id, this.column);
      },
      beforeClose() {
        this.supplierName = this.checkList.name;
        this.btnClick = false;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/business/supplierInputDialog.vue